import { render, staticRenderFns } from "./ResultsTableRow.vue?vue&type=template&id=5954f8d9&"
import script from "./ResultsTableRow.vue?vue&type=script&lang=js&"
export * from "./ResultsTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports